module.exports = __webpack_public_path__ + "img/ss2 copy.8ac8e8bb.png";